import styled from "styled-components";
import { Text } from "@ficatranquilo/contabilidade.com-ui";
import { OW_ASSETS, PoweredBy } from "@components/ow";

/**
 * Página do modelo Página pública do DS OneWork: as telas fora do AppShell (cadastro,
 * convite, seleção de empresa e os avisos), numa coluna centrada com o logo OneWork.
 * Mesma ideia das telas de erro do ft-app-web.
 *
 * Sem <form>, como o modelo Formulário: quem envia é o `$action` do botão principal, e
 * o `submitOnEnter` devolve o Enter nos campos.
 */

const Page = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100dvh;
  background-color: ${({ theme }) => theme.colors.N50};
`;

const Main = styled.main`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex: 1;
  gap: 30px;
  padding: 40px 30px;
`;

const Logo = styled.img`
  display: block;
  width: auto;
  height: 40px;
`;

const Heading = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  width: 100%;
  max-width: 560px;
  text-align: center;
`;

const Body = styled.div`
  width: 100%;
  max-width: 560px;
`;

const Actions = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 20px;

  button {
    min-width: 240px;
  }
`;

/** Cartão dos formulários e da lista de empresas, com o fundo e o raio da FormBox da lib. */
export const PublicBox = styled.div`
  display: flex;
  flex-direction: column;
  gap: 25px;
  padding: 24px;
  border-radius: 14px;
  background-color: ${({ theme }) => theme.colors.N0};
`;

/** Campos do cartão, um embaixo do outro. */
export const PublicFields = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

/** Rodapé do cartão: o link à esquerda e a ação principal à direita. */
export const PublicBoxFooter = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 20px;
`;

/** Envia com Enter num campo (em botão e link, o Enter já é o clique deles). */
export const submitOnEnter = (submit) => (event) => {
  if (event.key === "Enter" && event.target.tagName === "INPUT") submit();
};

/** `title` e `description` vão como HTML no Text da lib: texto digitado entra escapado. */
export function PublicPage({ title, description, headerExtra, children, actions }) {
  return (
    <Page>
      <Main>
        <Logo src={OW_ASSETS.full} alt="OneWork" />
        <Heading>
          <Text $text={title} $variant="h2_medium" $color="N900" />
          {description ? <Text $text={description} $variant="paragraph_regular_medium" $color="N500" /> : null}
          {headerExtra}
        </Heading>
        {children ? <Body>{children}</Body> : null}
        {actions ? <Actions>{actions}</Actions> : null}
      </Main>
      <PoweredBy />
    </Page>
  );
}

export function PublicLoading({ text }) {
  return (
    <Page aria-busy="true">
      <Main>
        <Logo src={OW_ASSETS.full} alt="OneWork" />
        <Text $text={`${text}…`} $variant="paragraph_regular_medium" $color="N500" />
      </Main>
    </Page>
  );
}
